import React from "react";
import deletionPdf from "./dojo-deletion.pdf";

const DojoDeletionPage = () => {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden", margin: 0, padding: 0, backgroundColor: "#525659" }}>
      <iframe
        src={`${deletionPdf}#toolbar=1`}
        title="Dojo Deletion Policy PDF"
        width="100%"
        height="100%"
        style={{ border: "none", display: "block" }}
      />
    </div>
  );
};

export default DojoDeletionPage;
